import * as core from '../../../../../../../core'

import { query } from './communications-needed-by-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'communications.needed.by.functional.area',
    description: 'Chart view of communications needed by functional area',
    name: 'Communications Needed by Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
